<template>

</template>

<script>
import {EventBus} from "../../../mixins/event-bus";
import axios from "axios";
import Cookies from "../../../mixins/cookies";


export default {
    name: "tasks-index-oracle",
    mixins: [Cookies],
    props: {
        libraryId: {
            type: Number,
            required: true
        },
        dataUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            libraryID: null
        }
    },
    methods: {
        reloadData() {
            let self = this;
            axios.get(this.dataUrl, {params: {
                         library_id: self.libraryID
                     }})
                 .then(function (response) {

                     EventBus.$emit('libraryChangeEventData', {
                         module: response.data.modules,
                         criterion: response.data.criteria,
                         status: response.data.statuses,
                         consultant_id: response.data.consultants,
                     });

                 }).catch(function (error) {
                console.log(error);
            });
        },
    },
    mounted() {
        EventBus.$on('libraryChangeEvent', (result) => {
            this.libraryID = result.library_id;
            this.reloadData();
        });
        this.libraryID = this.libraryId;

        let collapse = $('#collapseExtendedSearch'),
            self     = this;

        collapse.on('shown.bs.collapse', function () {
            self.setCookie('tasksIndexCollapseState', 'open', 1);
        })
        collapse.on('hidden.bs.collapse', function () {
            self.setCookie('tasksIndexCollapseState', 'close', 1);
        })
    }
}
</script>

